import { z } from "zod";
import { emailSchema, passwordSchema } from "./auth";

export const changePasswordValidationSchema = z
  .object({
    oldPassword: z.string().trim().min(1, "Password is required"),
    newPassword: passwordSchema,
    confirmPassword: z.string(),
  })
  .refine((data) => data.newPassword === data.confirmPassword, {
    message: "Passwords must match",
    path: ["confirmPassword"],
  });

export const changePersonalInfoValidationSchema = z.object({
  fullName: z
    .string({
      required_error: "Full name is required",
    })
    .trim()
    .min(1, "Full name is required"),
  email: emailSchema,
  country: z.string().optional(),
});

export const WRONG_OLD_PASSWORD_ERR = "Incorrect current password.";
